<p-toast
  key="toast-prime-component"
  [position]="'top-right'"
  [showTransformOptions]="'translateX(100%)'"
  [style]="{ maxWidth: '350px' }"
  preventOpenDuplicates
>
  <ng-template pTemplate="message" let-message>
    <div
      class="main-container flex items-start gap-spacing-xs"
      [class.cursor-pointer]="!!message.data?.clickCb"
      (mousedown)="message.data?.clickCb()"
    >
      <i
        class="flex align-items-center justify-content-center ph"
        [class.ph-fill]="message.severity === 'success'"
        [class.ph-check-circle]="message.severity === 'success'"
        [class.ph-info]="message.severity === 'info'"
        [class.ph-warning]="message.severity === 'warn'"
        [class.ph-x-circle]="message.severity === 'error'"
      ></i>
      <div class="flex gap-spacing-default flex-column">
        <div class="label-large-bold">
          {{ message.summary }}
        </div>
        <div class="label-large-regular">{{ message.detail }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>
